export default function NumberOrNAFilter($filter) {
  'ngInject';

  return function (amount) {
    if (amount == null) {
      return 'N/A';
    }

    return $filter('number')(amount);
  };
}
